import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/recordNo'
import Home from '@/views/index'
import {hasPermission} from '../utils/index'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

const  router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { title: '登录',hidden:true},
    },
    {
      path: '/refresh',
      name: 'refresh',
      component: () => import('../views/tokenRefresh.vue'),
      meta: { title: '刷新token',hidden:true},
    },
    {
      path: '/expired',
      name: 'expired',
      component: () => import('../views/expired.vue'),
      meta: { title: '登录超时',hidden:true},
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: { title: '系统设置',hidden:false},
      redirect:'/welcome',
      children: [
        {
          path: '/welcome',
          name: 'welcome',
          component: () => import('../views/home/welcome.vue'),
          meta: { title: '欢迎' }
        },
        {
          path: '/system',
          name: 'system',
          component: () => import('../views/home/ManageSystem/index.vue'),
          meta: { title: '系统配置' }
        },
        {
          path: '/admin',
          name: 'manageUser',
          component: () => import('../views/home/ManageUser/index.vue'),
          meta: { title: '用户管理'}
        },
        {
          path: '/rule',
          name: 'manageMenu',
          component: () => import('../views/home/ManageMenu/index.vue'),
          meta: { title: '菜单管理'}
        },
        {
          path: '/admin_log',
          name: 'manageLog',
          component: () => import('@/views/home/ManageLog/index.vue'),
          meta: { title: '日志管理' }
        },

      ]
    },
    {
      path: '/config_management',
      name: 'config_management',
      component: Home,
      meta: { title: '配置管理',hidden:false},
      redirect:'/welcome',
      children: [
        {
          path: '/config_management/default_show',
          name: 'config_management/default_show',
          component: () => import('@/views/ManageConfig/ConfigDefault/index.vue'),
          meta: { title: '默认显示配置' }
        },

      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.query && to.query.code){
    localStorage.setItem('code',to.query.code)
  }
  if (to.path != '/expired'){
    let payload =  JSON.parse(localStorage.getItem('token'))
    if (payload ){
      if(hasPermission(to.path)){
        next()
      }else{
        next({
          path: '/welcome',
        })
      }
    }
  }
  next()
})


export default router;